import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import DevAuthGuard from "./config/DevAuthGuard.tsx";
import "./index.css";
import { SnackbarProvider } from "./providers/SnackbarProvider.tsx";
import { ThemeProvider } from "./providers/ThemeProvider.tsx";

const isProduction = import.meta.env.VITE_PROD === "true";

const AppContent = (
  <ThemeProvider>
    <SnackbarProvider>
      <App />
    </SnackbarProvider>
  </ThemeProvider>
);

createRoot(document.getElementById("root")!).render(
  isProduction ? AppContent : <DevAuthGuard>{AppContent}</DevAuthGuard>
);
